var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hotspot-ui',_vm._g({staticClass:"vca-hotspot",class:{
    visited: _vm.visited,
  },attrs:{"spot-config":_vm.spotConfig,"action":_vm.action}},( _obj = {}, _obj[_vm.action.type] = _vm.execAction, _obj )),[_c('div',{staticClass:"vca-hotspot-inner"},[_vm._v(_vm._s(_vm.category === "number" ? _vm.idx : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }